import { PushNotificationStatus } from "../models/push-notification-status.enum";
import { PushNotificationPayload } from "../models/push-notification.model";

export namespace PushNotificationActions {
    export class AddNotification {
        public static readonly type = "[PushNotification] AddNotification";
        constructor(public payload: PushNotificationPayload) {}
    }

    export class LoadStoredNotifications {
        public static readonly type = "[PushNotification] LoadStoredNotifications";
    }

    export class GetAllNotifications {
        public static readonly type = "[PushNotification] GetAllNotifications";
    }

    export class GetUnreadNotifications {
        public static readonly type = "[PushNotification] GetUnreadNotifications";
    }

    export class GetUnreadCount {
        public static readonly type = "[PushNotification] GetUnreadCount";
    }

    export class SetNotificationStatus {
        public static readonly type = "[PushNotification] SetNotificationStatus";
        constructor(public notificationId: string, public status: PushNotificationStatus) {}
    }

    export class MarkAllAsRead {
        public static readonly type = "[PushNotification] MarkAllAsRead";
    }

    export class ClearAllNotifications {
        public static readonly type = "[PushNotification] ClearAllNotifications";
    }
}
